export const KEY = 'bJBnLgH2Mh75krorStMXXcUgz';
export const SECRETKEY = 'QxcTlzm3QJyZ45If6CdDKlSQzxZfnpu2D0gDjOXSUivpZEJbyq';
export const AUTHKEY = 'AIzaSyBr2zfXgAE3c3dmSR4zLMcp1wnaB_QAguE';
export const TOKEN =
  'Bearer AAAAAAAAAAAAAAAAAAAAAM28HAEAAAAAEqkPw9NIYq7bm9IsU5r%2FBAbtd9E%3DWwEDbHg3HwPIYM8BMSZSF5R15oajo2CCSmy0AGcOCqhJ3qLbf4';
